import { render, staticRenderFns } from "./swiper-pagination-primary.vue?vue&type=template&id=5c1ed9ff&scoped=true&"
import script from "./swiper-pagination-primary.vue?vue&type=script&lang=js&"
export * from "./swiper-pagination-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ed9ff",
  null
  
)

export default component.exports